export default "__VITE_PUBLIC_ASSET__43362e05__"